import { Mixin } from '@xingternal/hops-mixin';
import { datadogRum } from '@datadog/browser-rum';
import { getConfig } from './config';

class HopsDatadogBrowserMixin extends Mixin {
  bootstrap() {
    const {
      enabled,
      stage,
      applicationId,
      clientToken,
      service,
      version,
      costCenter,
      sessionSampleRate,
    } = getConfig(this.config);

    if (!enabled) {
      return;
    }

    datadogRum.init({
      applicationId,
      clientToken,
      service,
      version,

      env: stage,
      defaultPrivacyLevel: 'mask',
      sessionReplaySampleRate: 0,
      sessionSampleRate,
      trackUserInteractions: false,
      site: 'datadoghq.eu',
    });

    datadogRum.setGlobalContextProperty('cost_center', String(costCenter));
    datadogRum.setGlobalContextProperty('application', service);
  }
}

export default HopsDatadogBrowserMixin;
